﻿import { placeHolderMap } from './utilities.js';
import { _ve103Form } from './i247.VehicleLookup.js';

class Common {
	static HideUserMessage() {
		$('#UserMessage').hide();
	}

	static ShowUserMessage(title, message, hidePanels) {
		if (hidePanels) {
			$('#mainContent').hide();
		}
		
		$('#UserMessage #UserMessage_Title').html(title);
		$('#UserMessage #UserMessage_Message').html(message);
		$('#UserMessage').show();
	}

	static ShowGenericError() {
		$('#ErrorDialog').kendoDialog({
			width: '450px',
			title: 'Error',
			closable: true,
			modal: false,
			content: 'Sorry, an error occured. Please try again or contact your dedicated Driverline for assistance'
		});
	}

	static GetExtraValidator() {	
		var dropDownValid = true;

		var colour = $('#vehicle-colour-select');
		if (colour[0] !== null) {
			colour.parent().removeClass('k-invalid');
			if (colour.val() === '') {
				colour.parent().addClass('k-invalid');
				dropDownValid = false;
			}
		}

		var seats = $("#vehicle-number-of-seats-select");
		if (seats[0] !== null) {
			seats.parent().removeClass('k-invalid');
			if (seats.val() === '') {
				seats.parent().addClass('k-invalid');
				dropDownValid = false;
			}
		}

		var vehicleClass = $('#vehicle-class-select');
		if (vehicleClass[0] !== null) {
			vehicleClass.parent().removeClass('k-invalid');
			if (vehicleClass.val() === '') {
				vehicleClass.parent().addClass('k-invalid');
				dropDownValid = false;
			}
		}

		return dropDownValid;			
    }

	static GetVehicleValidator() {
		return $('#Mileage').kendoValidator({
			rules: {
				minimumMileageRequired: function (input) {
					var mileageSupplied = $('#Mileage').val().replace(/\,/g, '');
					var currentMileage = $('#VehicleMileage').val();
					var ConfirmMileageCheckBox = $('#ConfirmMileageCheckBox').is(':checked');
					if (input.is('#Mileage')) {
						if (parseInt(currentMileage) > parseInt(mileageSupplied) && !ConfirmMileageCheckBox) {
							let msg = `The mileage provided is lower than the last reading (${currentMileage}). <br/>Check this box to confirm the mileage you have entered is correct, or re enter.`;
							$('#ConfirmMileageCheckBox').next().addClass('k-checkbox-label').html(msg);
							$('#ConfirmMileageContainer').removeClass('d-none').addClass('d-inline-block');
							$('#vehicle-mileage').text(currentMileage);
							return false;
						} else if (!ConfirmMileageCheckBox) {
							$('#ConfirmMileageContainer').removeClass('d-inline-block').addClass('d-none');
                        }

						if (parseInt(mileageSupplied) > 2000000) {
							let msg = `The provided mileage can not be higher than 2,000,000 miles!`;
							$('#ConfirmMileageCheckBox').next().removeClass('k-checkbox-label').html(msg);
							$('#ConfirmMileageContainer').removeClass('d-none').addClass('d-inline-block');
							return false;
						} else if (!ConfirmMileageCheckBox) {
							$('#ConfirmMileageContainer').removeClass('d-inline-block').addClass('d-none');
						}
					}

					return true;
				}
			},
			messages: {
				minimumMileageRequired: 'Invalid mileage. Must be greater than previous mileage.'
			}
		}).data('kendoValidator');
	}

	static BindValidationStyles(validator) {
		validator.bind("validate", function (e) {
			let $container = $(e.sender.element);
			let $invalidInputs = $container.find(".k-invalid");
			let validationManager = {
				_tooltipTemplate: `<div class="tooltip tooltip-error tooltip-checkbox" role="tooltip"><div class="arrow tooltip-arrow-error"></div><div class="tooltip-inner tooltip-inner-error"></div></div>`,
				_highlightLabel: (invalidInput) => $(invalidInput).closest(".row").find("label:not(.k-radio-label)").addClass("error-label"),
				applyPrivacyCheckboxInputValidationStyle: invalidInput => {
					$(invalidInput).prop("data-toggle", "tooltip");
					$(invalidInput).parent().find("label").addClass("privacy-checkbox-validation-label");
					$(invalidInput).tooltip({
						boundary: "body",
						trigger: "manual",
						placement: "auto",
						template: validationManager._tooltipTemplate
					});
					$(invalidInput).tooltip("show");
				},
				applyLabelLessTextboxValidationStyle: invalidInput => {
					const errorMessage = $(invalidInput).parent().find('.k-tooltip-validation.k-invalid-msg').text();
					if ($(invalidInput).parent().find(".error-icon-absolute").length === 0) {
						let newElement = `<i class="fas fa-exclamation-circle error-icon-absolute" style="left: ${$(invalidInput).position().left + 15}px; top: ${$(invalidInput).position().top + 8}px;" data-toggle="tooltip" title="${errorMessage}" tabindex="-1"></i>`;
						$(invalidInput).parent().append(newElement);
						$('[data-toggle="tooltip"]').tooltip({
							boundary: "body",
							trigger: "focus",
							placement: "auto",
							template: validationManager._tooltipTemplate
						});
						placeHolderMap.set(invalidInput, $(invalidInput).prop("placeholder"));
						$(invalidInput).removeAttr("placeholder");
					}
				},
				applyGenericValidationStyle: invalidInput => {
					const errorMessage = $(invalidInput).closest(".row.form-group").find(".k-tooltip-validation.k-invalid-msg").text();
					const newElement = `<i class="fas fa-exclamation-circle error-icon" data-toggle="tooltip" title="${errorMessage}" tabindex="-1"></i>`;
					if ($(invalidInput).closest(".row.form-group").find(".error-icon").length === 0) {
						validationManager._highlightLabel(invalidInput);
						$(invalidInput).closest(".row.form-group").find("label:not(.k-radio-label)").append(newElement);
						$('[data-toggle="tooltip"]').tooltip({
							boundary: "body",
							trigger: "focus",
							placement: "auto",
							template: validationManager._tooltipTemplate
						});
						if ($(invalidInput).is(':radio')) {
							$(invalidInput).closest(".row.form-group").find(".k-radio-label").addClass("error-radio-btn-label");
						}
					}
				},
				applyWheelplanPanelValidation: invalidPanel => {
					let newElement = `<i class="fas fa-exclamation-circle error-icon-absolute" style="left: 30px; top: 15px;" data-toggle="tooltip" title="${$(invalidPanel).parent().find('.k-tooltip-validation.k-invalid-msg').text()}" tabindex="-1"></i>`;
					$(invalidPanel).parent().append(newElement);
					$('[data-toggle="tooltip"]').tooltip({
						boundary: "body",
						trigger: "focus",
						placement: "auto",
						template: validationManager._tooltipTemplate
					});
				},
				applyBtnValidationStyle: invalidInput => {
					const $btn = $(invalidInput).parent().find(".btn-to-validate");
					const errorMessage = $(invalidInput).parent().find(".k-invalid-msg").text();
					const newElement = `<i class="fas fa-exclamation-circle error-icon" data-toggle="tooltip" title="${errorMessage}" tabindex="-1"></i>`;
					$btn.before(newElement);
					$('[data-toggle="tooltip"]').tooltip({
						boundary: "body",
						trigger: "focus",
						placement: "auto",
						template: validationManager._tooltipTemplate
					});
				}
			};

			if ($container.is('[id^="wheelPlanSection"]')) {
				validationManager.applyWheelplanPanelValidation($container.find('.tyreDetailInvalid'));
			} else {
				if ($invalidInputs) {
					$invalidInputs.each((index, invalidInput) => {
						if (!$invalidInputs.hasClass('noValidationStyle')) {
							// Making sure the input is not hidden
							let isHidden = $(invalidInput).is(':hidden');
							let isDropDownList = $(invalidInput).data("role") === "dropdownlist";
							if (!isHidden || (isHidden && isDropDownList)) {
								// check if input is single checkbox
								if ($(invalidInput).hasClass('privacyCheckboxValidation')) {
									validationManager.applyPrivacyCheckboxInputValidationStyle(invalidInput);
								} else
									// check if input is textbox and without label, if so apply icon within
									if (($(invalidInput).is('input:text') && $(invalidInput).data('role') !== 'dropdownlist') && ($(invalidInput).closest('.row.form-group').length === 0 || $(invalidInput).closest('.form-group.row').find('label:not(.k-radio-label)').length === 0)) {
										validationManager.applyLabelLessTextboxValidationStyle(invalidInput);
									}
									else if (isDropDownList) {
										validationManager.applyGenericValidationStyle(invalidInput);
										$(invalidInput).prevAll().closest(".k-dropdown-wrap").addClass('invalid-border');
									}
									else {
										// for everything else apply generic styles
										validationManager.applyGenericValidationStyle(invalidInput);
									}
							}
							else if ($(invalidInput).hasClass('btn-validation-input')) {
								validationManager.applyBtnValidationStyle(invalidInput);
							}
						}
					});
				}
			}
		});
	}

	static RemoveValidationStyles(input, panel) {
		if (input) {
			const removeHighlightLabel = (invalidInput) => $(invalidInput).closest('.row.form-group').find('label').removeClass('error-label');
			const removeErrorIcon = (invalidInput) => $(invalidInput).closest('.row.form-group').find('label').find('.error-icon').remove();
			const removeErrorIconOnBtn = (invalidHiddenInput) => $(invalidHiddenInput).parent().find('.error-icon').remove();
			const removeInputErrorIcon = (invalidInput) => {
				const errorIconEl = $(invalidInput).parent().find('.error-icon-absolute');
				if (errorIconEl.length !== 0) {
					errorIconEl.remove();
					if (placeHolderMap.has(input)) {
						placeHolderMap.get(input);
						$(input).attr('placeholder', placeHolderMap.get(input));
						placeHolderMap.delete(input);
					}
				}
			};
			const removeKendoHighlight = (invalidInput) => $(invalidInput).removeClass('k-invalid');
			const removePrivacyCheckboxValidationStyles = (invalidInput) => {
				$(invalidInput).removeAttr('data-toggle');
				$(invalidInput).parent().find('label').removeClass('privacy-checkbox-validation-label');
			};

			if ($(input).prop('data-toggle') === 'tooltip') {
				// dispose of a tooltip when applied to the DOM Element itself.
				$(input).tooltip('dispose');
			} else {
				// dispose of a tooltip when applied to the DOM Element parent.
				$(input).closest('.row').find('[data-toggle="tooltip"]').tooltip('dispose');
			}

			if ($(input).hasClass('privacyCheckboxValidation')) {
				removePrivacyCheckboxValidationStyles(input);
			} else if ($(input).hasClass('noLabelValidation')) {
				removeInputErrorIcon(input);
			} else {
				removeHighlightLabel(input);
				removeErrorIcon(input);
				removeErrorIconOnBtn(input);
				removeKendoHighlight(input);

				let isDropDownList = $(input).data("role") === "dropdownlist";
				if ($(input).is(':radio')) {
					$(input).closest('.row.form-group').find('.k-radio-label').removeClass('error-radio-btn-label');
				}
				else if (isDropDownList) {
					$(input).prevAll().closest(".k-dropdown-wrap").removeClass('invalid-border');
				}
			}
		} else if (panel && panel.length > 0) {
			$(panel).find('[data-toggle="tooltip"]').tooltip('dispose');
			$(panel).find('.error-icon-absolute').remove();
			$(panel).find('.tyreDetailInvalid').removeClass('tyreDetailInvalid');
		}
	}

	static Bounce(element, times, distance, speed) {
		for (var i = 0; i < times; i++) {
			element.animate({ marginTop: '-=' + distance }, speed)
				.animate({ marginTop: '+=' + distance }, speed);
		}
    }

	static InitialiseEmailSupportTab() {
		$('#email-tab').click(() => {
			$("#help-form").detach().appendTo('#email-container');
			$('#email-container').toggle('slide');
		});

		$('#supportModalBtn').click(() => {
			$("#help-form").detach().appendTo('#mobile-email-container');
			$('#emailModal').toggle('slide');
		});

		if ($('#fullPageContainer[data-formName="VE103"]').length) {
			$('#supportModalBtn').removeClass('d-none').show();
		}

		[$('#supportLargeScreenForm'), $('#supportSmallScreenForm')].forEach(form => {
			form.on('submit', (event) => {				
				if (event.target.checkValidity() === false) {
					event.preventDefault();
					event.stopPropagation();
				} else {
					let driverData = null;
					let endpoint = null;
					let $formContainer = $(event.target).closest('.form');
					$formContainer.find('#sendSupportEmail').prop('disabled', true);

					let formData = {
						fullname: $formContainer.find('#user-name').val(),
						email: $formContainer.find('#user-email').val(),
						phone: $formContainer.find('#user-phone').val(),
						note: $formContainer.find('#user-note').val()
					};
					let formName = $('#fullPageContainer').attr('data-formName');
					switch (formName) {
						case 'VE103':
							driverData = _ve103Form.model;
							endpoint = '/foreigntravel/SendSupportEmail';
							break;
						default: driverData = null;
							break;
					}
					let data = { 'driverData': driverData, 'formData': formData };
                    $.ajax({
                        type: 'POST',
                        url: endpoint,
                        data: data,
                        success: function () {
							$('#email-container, #emailModal').find('#confirmationMessage').show(),
                                setTimeout(function() {
									$('#email-container, #emailModal').find('#confirmationMessage').fadeOut();
									$('#email-container, #emailModal').toggle('slide').find('textarea').val('');
									$('.modal-backdrop, #emailModal').hide();
                                }, 3000);
                        },
                        error: () => console.log('error sending email.')
                    });
				}
				event.target.classList.add('was-validated');
				event.preventDefault();
			});
		});		
	}

	static GetQueryStringValue(key, url) {
		if (!url) url = window.location.href;

		key = key.replace(/[\[\]]/g, '\\$&');

		var regex = new RegExp('[?&]' + key + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);

		if (!results) return null;

		if (!results[2]) return '';

		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}
}

export default Common;

$(document).ready(function () {	
	if (LAYOUT_MODE == 'mode2') {
		$('#breadcrumb').detach().prependTo('#mainContent');
	}
	$('body').removeClass('d-none');

	$('.tip').tooltip({
		boundary: "body",
		trigger: "focus",
		placement: "auto"
	});

	$(document).on('focus focusout click', 'input.k-invalid', event => Common.RemoveValidationStyles(event.target));

	$(document).on('change', '.k-dropdown', event => Common.RemoveValidationStyles(event.target));

	$(document).on('click', '.btn', event => Common.RemoveValidationStyles(event.target));

	document.documentElement.style.setProperty('--customer-font-family', SITE_FONT_FAMILY);
	document.documentElement.style.setProperty('--customer-color', SITE_COLOR);
	document.documentElement.style.setProperty('--customer-sub-color', SITE_COLOR2);
	document.documentElement.style.setProperty('--customer-color-gradient1', SITE_COLOR_GRADIENT_1);
	document.documentElement.style.setProperty('--customer-color-gradient2', SITE_COLOR_GRADIENT_2);
	document.documentElement.style.setProperty('--customer-color-gradient3', SITE_COLOR_GRADIENT_3);
	document.documentElement.style.setProperty('--customer-color-gradient4', SITE_COLOR_GRADIENT_4);
	document.documentElement.style.setProperty('--customer-header-bar-style', SITE_HEADER_BAR_STYLE);
	document.documentElement.style.setProperty('--customer-header-row-style', SITE_HEADER_ROW_STYLE);

	if (SITE_TITLE_BAR_COLOR_USE_GRADIENT.toUpperCase() === 'TRUE') {
		document.documentElement.style.setProperty('--customer-title-bar-color-gradient1', SITE_COLOR_GRADIENT_1);
		document.documentElement.style.setProperty('--customer-title-bar-color-gradient2', SITE_COLOR_GRADIENT_2);
		document.documentElement.style.setProperty('--customer-title-bar-color-gradient3', SITE_COLOR_GRADIENT_3);
		document.documentElement.style.setProperty('--customer-title-bar-color-gradient4', SITE_COLOR_GRADIENT_4);
	} else {
		document.documentElement.style.setProperty('--customer-title-bar-color-gradient1', SITE_COLOR);
		document.documentElement.style.setProperty('--customer-title-bar-color-gradient2', SITE_COLOR);
		document.documentElement.style.setProperty('--customer-title-bar-color-gradient3', SITE_COLOR);
		document.documentElement.style.setProperty('--customer-title-bar-color-gradient4', SITE_COLOR);
	}

	$('.view-privacy-policy').on('click', event => {
		$('#privacyPolicy').toggleClass('d-none');
	});	
});
